:host {
  display: block;
  max-width: 100%;
}

.wrapper {
  padding: calc(var(--spacer) * 2) calc(var(--spacer) * 5);
}

.file-archive-details {
  font-size: var(--small-button-font-size);
  color: var(--chart-300-icon-buttons);
  font-weight: 600;
  text-transform: uppercase;
}

gz-form-field::part(form-field-label) {
  text-transform: uppercase;
  font-weight: 500;
  font-size: var(--body-size);
}

gz-labeled-content[id='archive-password-label'],
gz-labeled-content[id='repeat-password-label'] {
  --value-width-percentage: 85%;
  --label-width-percentage: 15%;
}

.archive-password-details {
  width: 240px;
  white-space: normal;
  padding: 0 var(--spacer);
}

gz-info-box {
  width: 540px;
  margin-left: calc(var(--spacer) * -1);
}

.password-protect-fields {
  margin-left: 43px;
}

gz-text[id='download-path-information'],
gz-text[id='file-archive-details-information'] {
  width: 50%;
}

gz-toggle[id='password-protect'] {
  width: fit-content;
}
